export const LogoIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="2 2 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.9944C17.5228 21.9944 22 17.5185 22 11.9972C22 6.47589 17.5228 2 12 2C6.47715 2 2 6.47589 2 11.9972C2 17.5185 6.47715 21.9944 12 21.9944Z"
      fill="#DAD5FF"
    />
    <path
      d="M6.74805 20.5054C6.74805 20.5054 12.365 23.376 14.9656 17.6773C17.5663 11.9786 16.9863 7.94614 20.7266 7.11304C20.7266 7.11304 21.6649 8.98982 21.8164 10.0834C21.8164 10.0834 20.2002 10.7133 18.9996 15.8116C17.799 20.91 14.864 21.5879 14.5482 21.6655C14.2323 21.7431 10.2981 22.8662 6.74989 20.5054H6.74805Z"
      fill="#8358FA"
    />
    <path
      d="M20.0323 6.04166C20.0323 6.04166 16.8665 4.22769 14.7553 7.22573C12.6441 10.2238 13.5768 17.0013 7.75489 16.7796C1.93295 16.5579 1.38068 8.71091 5.68803 4.9167C9.1993 1.8226 13.1742 1.79304 14.9178 2.43403C16.4139 2.9845 18.2333 3.70123 20.0323 6.04166Z"
      fill="#8358FA"
    />
  </svg>
);
